/**
 * Build a visitor share UTM URL.
 * Reuses the same /share/event/:id proxy path for OG metadata.
 */

const BASE_URL = 'https://www.farmly.se';

export function buildVisitorShareUrl(eventId: string): string {
  const params = new URLSearchParams({
    utm_source: 'visitor',
    utm_medium: 'share',
    utm_campaign: 'friend_invite',
    utm_content: eventId,
  });
  return `${BASE_URL}/share/event/${eventId}?${params.toString()}`;
}
